export default function StepTitle(props) {
    return <div className={'text-lg border border-t-0 border-l-0 border-r-0 p-2'}>{props.children}</div>
}